import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

    static targets = [ "submitButton", "inputCheckbox" ]

    connect() {
        this.toggleSubmitButton();
    }

    toggleSubmitButton() {
        if (this.inputCheckboxTargets.some((checkbox) => checkbox.checked)) {
            this.submitButtonTarget.removeAttribute("disabled");
        } else {
            this.submitButtonTarget.setAttribute("disabled", "disabled");
        }
    }

}